// @flow

const routes = {
  '/about': {
    fetch: () =>
      import(/* webpackChunkName: 'about-route' */ 'app/about/asyncRoute').then(
        module => module.default
      ),
  },
};

export default routes;
